import SEO from "@/components/SEO";
import { SeoPageShell, HeroH1, H2, P, InlineLink } from "@/pages/seo/SeoPageLayout";

const Professionals = () => (
  <SeoPageShell>
    <SEO
      title="For Professionals — Therapists, Advocates & Legal Aid | GreyRock AI®"
      description="A text-analysis tool for therapists, DV advocates and legal aid staff to identify coercive control, DARVO and high-conflict patterns in client messages."
      path="/professionals"
      jsonLd={[
        {
          "@context": "https://schema.org",
          "@type": "WebPage",
          name: "GreyRock AI® for Professionals",
          url: "https://greyrockai.app/professionals",
          description:
            "A text-analysis tool for therapists, DV advocates and legal aid staff to identify coercive control, DARVO and high-conflict patterns in client messages.",
          audience: { "@type": "Audience", audienceType: "Therapists, domestic violence advocates, legal aid professionals" },
          publisher: { "@type": "Organization", name: "GreyRock AI®", url: "https://greyrockai.app" },
        },
        {
          "@context": "https://schema.org",
          "@type": "BreadcrumbList",
          itemListElement: [
            { "@type": "ListItem", position: 1, name: "Home", item: "https://greyrockai.app/" },
            { "@type": "ListItem", position: 2, name: "For Professionals", item: "https://greyrockai.app/professionals" },
          ],
        },
      ]}
    />

    <HeroH1>GreyRock AI® for professionals</HeroH1>

    <P>
      Therapists, advocates, and legal aid staff who work with coercive or high-conflict
      communication need clear, well-sourced ways to name what they see. GreyRock AI® maps
      communication patterns to published research, so they can be recognized and discussed in
      plain language.
    </P>

    <H2>Research grounding</H2>
    <P>
      The pattern taxonomy draws on published work — for example, Freyd on DARVO and Linehan on
      invalidating environments. See the pattern guides on{" "}
      <InlineLink to="/analysis/darvo-in-text-messages">DARVO in text messages</InlineLink>,{" "}
      <InlineLink to="/analysis/invalidation-patterns-in-texts">invalidation patterns</InlineLink> and{" "}
      <InlineLink to="/analysis/criticism-patterns-in-text-messages">criticism patterns</InlineLink>, or browse
      all <InlineLink to="/resources">resources</InlineLink>.
    </P>

    <H2>Training and content</H2>
    <P>
      We're exploring training material and licensed reference content for professionals and
      organizations. If that's relevant to your work,{" "}
      <a href="mailto:gmalik@greyrockai.app" className="text-cyan-300/90 underline-offset-4 hover:underline">
        email us
      </a>
      .
    </P>

    <H2>Privacy</H2>
    <P>
      The free analyzer runs entirely in your browser; the message text is not sent to a server.
      Signed-in paid analyses are stored in the user's account.
    </P>

    <div className="mt-10 rounded-lg border border-border bg-card/40 p-5 text-sm text-muted-foreground">
      GreyRock AI® is an educational tool. It does not provide diagnosis, clinical assessment, or
      legal advice. Please do not enter client or case-identifying information.
    </div>
  </SeoPageShell>
);

export default Professionals;
